<script>
	import * as VueGoogleMaps from 'vue2-google-maps';
	import {Form} from '../../helpers/Form/Form'

	export default {
		props: {
			company: Object,
			email: String
		},
		components: {
			'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
		},
		data() {
			return {
				types: ['geocode'],
				form: new Form({
					terms: false,
					name: this.company.name,
					email: this.email,
					address: this.company.short_address,
					latitude: this.company.latitude,
					longitude: this.company.longitude,
					company_id: this.company.id,
					addressComponents: null,
					password: null
				})
			}
		},
		methods: {
            getAddressData(payload) {
                this.form.address = payload.formatted_address;
                this.form.addressComponents = payload.address_components;
                this.form.latitude = payload.geometry.location.lat();
                this.form.longitude = payload.geometry.location.lng();
            },		
            onSubmit() {
            	this.form
            		.submit('post', route('companies.taking_charge'))
            		.then(response => {
            			location.href = route('companies.dashboard.home', this.company.slug)
            		})
            }	
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/company/CompanyTakingChargeModal.vue